var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"text-font"},[_c('v-content',[_c('installprompt'),_c('Navbar',{key:_vm.$route.fullPath}),_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }